import React, { useState } from 'react';
import type { DateOfBirthElement } from 'models/forms/formElements/DateOfBirthElement';

type Props = {
  element: DateOfBirthElement;
  isEditing: boolean;
  onUpdate: (updatedElement: DateOfBirthElement) => void;
  isDisabled?: boolean;
};

const DateOfBirthElementComponent: React.FC<Props> = ({ element, isEditing, onUpdate, isDisabled }) => {
  const [name, setName] = useState(element.name);

  if (isEditing) {
    return (
      <div>
        <p className="mb-1 text-sm text-gray-700">Label</p>
        <input
          type="text"
          value={name}
          onChange={(e) => {
            const next = e.target.value;
            setName(next);
            onUpdate({ ...element, name: next });
          }}
          className="block w-full px-3 py-2 border border-gray-300 rounded"
        />
      </div>
    );
  }

  return (
    <div className="mb-2.5">
      <label htmlFor={element.id} className="block mb-1.5 font-medium text-gray-700">
        {element.name}{element.isRequired ? ' *' : ''}
      </label>
      <input
        type="date"
        id={element.id}
        value={element.value || ''}
        onChange={(e) => onUpdate({ ...element, value: e.target.value })}
        className="px-3 py-2 border border-gray-300 rounded"
        disabled={isDisabled ?? false}
      />
    </div>
  );
};

export default DateOfBirthElementComponent;
